import NewspaperTips from './NewspaperTips'

export default NewspaperTips
